export const ENVIRONMENT = import.meta.env.VITE_APP_ENVIRONMENT;
export const APP_VERSION = import.meta.env.VITE_APP_VERSION;
export const PUBLIC_URL = import.meta.env.PUBLIC_URL;

export const API_BASE_URL = import.meta.env.VITE_APP_API_BASE_URL;
export const API_URL = import.meta.env.VITE_APP_API_URL;

export const PANEL_BETA_URL = import.meta.env.VITE_APP_PANEL_BETA_URL;

export const CHECK_APP_VERSION =
  (import.meta.env.VITE_APP_CHECK_APP_VERSION ?? "true") === "true";
